
import CONSTANTS from '../constants'
import { getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'



export const getCardLists = () => (dispatch) => {
    dispatch(addEventLog('' , CONSTANTS.GET_CARD_LIST_REQUEST ))
    dispatch({ type: CONSTANTS.GET_CARD_LIST_REQUEST })
    let endpoint = `${APICONFIG.getCardLists}`
    return getRequest(endpoint).then((res) => {
        dispatch(addEventLog(res , CONSTANTS.GET_CARD_LIST_SUCCESS ))
        dispatch({ type: CONSTANTS.GET_CARD_LIST_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch(addEventLog(err , CONSTANTS.GET_CARD_LIST_FAILURE ))
        dispatch({ type: CONSTANTS.GET_CARD_LIST_FAILURE })
        return err
    })
}

export const addCard = (payload) => (dispatch) => {
    let payloadCard = {...payload, 'device_type': 'web'}
    dispatch(addEventLog(payloadCard , CONSTANTS.ADD_CARD_REQUEST ))
    dispatch({ type: CONSTANTS.ADD_CARD_REQUEST })
    return postRequest(APICONFIG.addCard, payloadCard).then((res) => {
        let resObject = {...payloadCard, ...res}
        dispatch(addEventLog(resObject , CONSTANTS.ADD_CARD_SUCCESS))
        dispatch({ type: CONSTANTS.ADD_CARD_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = {...payloadCard, ...err}
        dispatch(addEventLog(errObject, CONSTANTS.ADD_CARD_FAILURE))
        dispatch({ type: CONSTANTS.ADD_CARD_FAILURE })
        return err
    })
}

export const deleteCard = (payload) => (dispatch) => {
    let payloadCard = {...payload, 'device_type': 'web'}
    dispatch(addEventLog(payloadCard , CONSTANTS.DELETE_CARD_REQUEST ))
    dispatch({ type: CONSTANTS.DELETE_CARD_REQUEST })
    return postRequest(APICONFIG.deleteCard, payload).then((res) => {
        let resObject = {...payloadCard, ...res}
        dispatch(addEventLog(resObject , CONSTANTS.DELETE_CARD_SUCCESS ))
        dispatch({ type: CONSTANTS.DELETE_CARD_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = {...payloadCard, ...err}
        dispatch(addEventLog(errObject , CONSTANTS.DELETE_CARD_FAILURE ))
        dispatch({ type: CONSTANTS.DELETE_CARD_FAILURE })
        return err
    })
}


export const makeDefaultCardData = (cardData) => dispatch => {
    let payloadCard = {...cardData, 'device_type': 'web'}
    dispatch(addEventLog(payloadCard, CONSTANTS.CARD_UPDATE_REQUEST))
    dispatch({ type: CONSTANTS.CARD_UPDATE_REQUEST })
    return postRequest(`${APICONFIG.updateDefaultCard}`, payloadCard).then((res) => {
        let resObject = {...payloadCard, ...res} 
        dispatch(addEventLog(resObject, CONSTANTS.CARD_UPDATE_SUCCESS))
        dispatch({ type: CONSTANTS.CARD_UPDATE_SUCCESS })
        return res
    }).catch((err) => {
        let errObject = {...payloadCard, ...err}
        dispatch(addEventLog(errObject, CONSTANTS.CARD_UPDATE_FAILED))
        dispatch({ type: CONSTANTS.CARD_UPDATE_FAILED })
        return err
    })
}